/**
 * Returns a boolean stating if target element is scrolled to the end
 * @param targetElement
 */
const isTargetElementTotallyScrolled = (targetElement: any): boolean =>
    targetElement
        ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight
        : false;

export default isTargetElementTotallyScrolled;
